<template>
  <router-view />
</template>

<script>
export default {
  created() {
    if (location.href.includes('/login')) return
    this.$api.getUserInfo()
      .then(({ data }) => {
        const { id, name, phone } = data
        this.$store.commit('setUserInfo', { id, name, phone })
        addPageWaterMarker({ content: `${ name } ${ String(phone).slice(-4) }`, font: '12px Microsoft Yahei', fillStyle: 'rgba(43,48,56, 0.1)' })
      })
  }
}
</script>
